<div class="container">
    <div class="px-3 versioncontainer">
        <markdown ngPreserveWhitespaces [data]="markdown"></markdown>
    </div>
</div>
